import { render, staticRenderFns } from "./VisualizarDadosModal.vue?vue&type=template&id=155eff9d&scoped=true"
import script from "./VisualizarDadosModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualizarDadosModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VisualizarDadosModal.vue?vue&type=style&index=0&id=155eff9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155eff9d",
  null
  
)

export default component.exports